<template>
    <v-text-field
      append-icon="search"
      :color="compColor.primeColor"
      :hide-details="true"
      class="flex elevation-0 mb-0"
      :placeholder="placeholder"
      :background-color="compColor.inputs"
      :dark="compColor.isInDarkMode"
      v-model="searchValue"
      :dense="dense"
      @click:append="dataMethod"
      @click:clear="clearSearchFn"
      v-on:keyup.enter="dataMethod"
      clearable
      outlined
    ></v-text-field>
</template>

<script>
import Vue from 'vue'

export default Vue.component('LxSearchField',{
  props: {
    placeholder: {
      type: String
    },
    dataMethod: Function,
    value: {
      type: String
    },
    dense: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      searchValue: null
    }
  },
  methods: {
    /**
     * Reset search string after clearing in template, value in controller must be updated manually
     */
    clearSearchFn () {
      this.searchValue = null

      this.$nextTick(() => {
        this.dataMethod()
      })
    }
  },
  watch: {
    searchValue: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            const validCharacters = /[^a-z0-9 .,:_öüäÖÜÄß-]/gi

            let replacedString = newValue.replace(validCharacters, '')
            if (replacedString !== newValue) newValue = replacedString
          }

          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchValue = newValue
        }
      },
      immediate: true
    }
  }
})
</script>
